export default "__VITE_ASSET__2df706c5__"